import React, { useEffect, useReducer, useRef } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Container, Row, Col, Input } from "reactstrap";
import PropTypes from "prop-types";

import { inOutReducer } from "./store/reducer";
import { defaultState, Dispatch, initialize } from "./store/store";
import { Default } from "./Forms";
import Footer from "./Footer";
import Precheck from "./Precheck/Precheck";
import style from "./IO.module.scss";
import { Mode } from "../../../utils";
import { formatIOforUpdate } from "../../IO/utils";
import { IOExecution } from "../..";
import { TransactionStatus, getIOProcessName } from "../../IO/types";
import { showToast } from "../../../utils/Helper";

export const onChange = (dispatch, fields) => dispatch({ type: "CHANGE_IO_FIELDS", fields });

export const onChangeItem = (dispatch, itemId, fields) => {
  dispatch({ type: "CHANGE_IO_ITEM_FIELDS", payload: { itemId, fields } });
};
export const onChangeHeader = (dispatch, fields) =>
  dispatch({ type: "CHANGE_IO_ITEMS_HEADER", payload: { fields } });

export const onChangeMode = (dispatch, mode) => dispatch({ type: "CHANGE_MODE", mode });

const InOut = ({ open, toggle, toggleInfo, services, userType, opsViewAccountName, ...props }) => {
  const [state, dispatch] = useReducer(inOutReducer, defaultState(), initialize(props));
  const { ui, io, fields, precheck } = state;
  const { readonly } = fields;
  const executionRef = useRef();

  const confirm = () => {
    if (ui.mode === Mode.EXECUTE) {
      execute();
    } else {
      const updIO = formatIOforUpdate(io);
      let hasErrors = false;

      // authorizations
      const authorizations = precheck.authorizations.map((auth) => {
        if (auth.text == null || !auth.text.length) {
          hasErrors = true;
          return { ...auth, error: "Required field", readonly: undefined };
        }

        return { ...auth, error: null, readonly: undefined };
      });

      if (!hasErrors) {
        authorizations.forEach((a) => (a.readonly = true));
      }

      dispatch({ type: "UPDATE_PRECHECK", fields: { authorizations } });

      if (!hasErrors) {
        // check if all authorizations can be authorized by self
        const allSelfAuth = precheck.authorizations.every((a) => a.role.toLowerCase() === "self");

        // if allSefAuth = true then order will has ROUTED status
        if (!allSelfAuth) {
          updIO.Status = TransactionStatus.AUTH_WAIT;
        } else if (io.Status === TransactionStatus.PARKED) {
          updIO.Status = TransactionStatus.ROUTED;
        }

        dispatch({
          type: "CHANGE_BUTTON_PROPS",
          props: { confirm: { loading: true }, modify: { visible: false } },
        });

        services
          .fetchUpdateIO({
            k2btrnmode: io.Id ? "UPD" : "INS",
            io: updIO,
          })
          .then((r) => r.response)
          .then((r) => {
            if (r.result.Code != 200) {
              dispatch({
                type: "CHANGE_BUTTON_PROPS",
                props: { confirm: { loading: false }, modify: { visible: true } },
              });
              showToast(r.result.Description, true);
            } else {
              if (io.Id) {
                const ioAccountsUpd = [];

                ui.addedItems &&
                  ui.addedItems.forEach((itemId) => {
                    ioAccountsUpd.push({
                      ...updIO.items.find((item) => item.Correlative == itemId),
                      mode: "INS",
                    });
                  });

                ui.changedItems &&
                  ui.changedItems.forEach((itemId) => {
                    ioAccountsUpd.push({
                      ...updIO.items.find((item) => item.Correlative == itemId),
                      mode: "UPD",
                    });
                  });

                ui.deletedItems &&
                  ui.deletedItems.forEach((item) => {
                    ioAccountsUpd.push({
                      ...item,
                      Id: io.Id,
                      mode: "DLT",
                    });
                  });

                if (ioAccountsUpd.length > 0) {
                  services.fetchUpdateIOAccount({
                    id: io.Id,
                    ioaccounts: ioAccountsUpd,
                  });
                }
              }

              const processName = getIOProcessName(updIO);
              // create authorizations
              new Promise((resolve) => {
                const authorizations = precheck.authorizations.map((authorization) => ({
                  ...authorization,
                  refid: r.id || io.Id,
                  process: processName,
                }));
                services.fetchAuthorizationCreate({ authorizations }).then((resp) => resolve(resp.response));
              });
              if (userType == "BackOffice")
                deleteFiles(io.id || r.id);
              uploadFiles(io.Id || r.id);
              toggle();
            }
          });
      }
    }
  };

  const uploadFiles = (ioId) => {
    const newFiles = io.files.filter((f) => f.hasOwnProperty("data"));
    if (newFiles.length > 0) {
      const filesFD = new FormData();

      newFiles.forEach((f, i) => {
        filesFD.append(`file${i + 1}`, f.data);
      });
      services
        .fetchUploadIOAttachments({
          id: ioId,
          ioType: io.IOType,
          files: filesFD,
        })
        .then(() => null);
    }
  };

  const deleteFiles = (ioId) => {
    if (io.removedItem) {
      const files = io.files.filter((f) => !f.hasOwnProperty("data"));
      const fileIds = files.map(file => file.id);
      services.DeleteFileIO({
        id: ioId,
        fileId: fileIds,
        ioType: io.IOType,
      })
    }
  }

  const execute = () => {
    const hasErrors = executionRef.current.validate();

    if (!hasErrors) {
      dispatch({
        type: "CHANGE_BUTTON_PROPS",
        props: { confirm: { loading: true }, modify: { visible: false } },
      });

      const updIO = formatIOforUpdate(io);

      services
        .fetchUpdateIO({
          k2btrnmode: io.Id ? "UPD" : "INS",
          io: updIO,
        })
        .then((r) => {
          if(r.response.result&& r.response.result.Code !== 200) {
            dispatch({
              type: "CHANGE_BUTTON_PROPS",
              props: { confirm: { loading: false }, modify: { visible: true } },
            });
            showToast(r.response.result.Description, true);
            return;
          }
          services
            .fetchChangeIOStatus({
              id: io.Id,
              ioType: io.IOType,
              newStatus: TransactionStatus.FILLED,
              parameter: JSON.stringify(executionRef.current.getValues()),
            })
            .then((r2) => {
              toggle();
              if (r2.error !== "") {
                toggleInfo({ message: r2.error });
              }
            });
        })
        .catch((e) => {
          dispatch({
            type: "CHANGE_BUTTON_PROPS",
            props: { confirm: { loading: false }, modify: { visible: true } },
          });
        });
    }
  };

  return (
    <Dispatch.Provider value={{ state, dispatch, services }}>
      <Modal isOpen={open} className={style.modal}>
        <ModalHeader toggle={toggle}>{ui.title}</ModalHeader>
        <ModalBody className={style.body}>
          {/* Precheck */}
          {ui.mode === Mode.PRECHECK && (
            <Precheck io={io} services={services} dispatch={dispatch} precheck={state.precheck} />
          )}
          {/* Form */}
          {ui.mode !== Mode.PRECHECK && (
            <React.Fragment>
              <Default ioType={io.IOType} ioMode={io.IOMode} {...props} opsViewAccountName={opsViewAccountName} />
              <Container>
                <Row>
                  <Col lg={12}>
                    <Input
                      className=""
                      type="textarea"
                      rows={2}
                      placeholder="Notes..."
                      value={io.Description || ""}
                      disabled={readonly.Description}
                      style={{ marginTop: "10px" }}
                      onChange={(e) => onChange(dispatch, { Description: e.target.value })}
                    />
                  </Col>
                </Row>
              </Container>
            </React.Fragment>
          )}
          {(ui.mode === Mode.EXECUTE || io.Status === TransactionStatus.FILLED) && (
            <IOExecution ref={executionRef} io={io} services={services} />
          )}
        </ModalBody>
        <ModalFooter>
          <Footer
            toggle={toggle}
            buttons={state.buttons}
            actions={{
              confirm,
            }}
          />
        </ModalFooter>
      </Modal>
    </Dispatch.Provider>
  );
};

InOut.propTypes = {
  services: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  toggleInfo: PropTypes.func,
};

export default InOut;
